import { Navigate } from "react-router-dom";
import { useAuthContext } from "../../context/auth";
import { Loader } from "../Loader";

const PrivateRoute = ({ children, allowedRoles, allowedIds = null, deniedIds = null }) => {
  const { session, rol, id, isLoading } = useAuthContext();

  if (isLoading || session === undefined) {
    return <Loader fullPage />;
  }

  const hasAllowedRole = allowedRoles.includes(rol);
  const hasAllowedId = allowedIds ? allowedIds.includes(id) : true;
  const isDenied = deniedIds ? deniedIds.includes(id) : false;

  if (isDenied) {
    return <Navigate to="/admin" replace />;
  }

  if (!session || !hasAllowedRole || !hasAllowedId) {
    return <Navigate to="/login" replace />;
  }

  return children;
};

export default PrivateRoute;
